import React, { useState } from 'react';
import { Input } from '@vimily/bonjoro-ui-components-v2/Input';
import ColorPickerPopover from '~/App/Components/ColorPickerPopover';
import cx from 'classnames';

export enum ColorPreviewShape {
  Circle = 'circle',
  Square = 'square',
}

export interface ColorPickerInputProps {
  onSelect?: (color: string) => void;
  onFocus?: () => void;
  disabled?: boolean;
  value?: string;
  shape?: ColorPreviewShape;
}

export function ColorPickerInput({
  onSelect,
  onFocus,
  disabled,
  value,
  shape = ColorPreviewShape.Square,
}: ColorPickerInputProps) {
  const [open, setOpen] = useState(false);

  const openColorPicker = () => {
    if (disabled) return;

    setOpen(true);
  };
  const closeColorPicker = () => setOpen(false);

  return (
    <ColorPickerPopover
      enableAlpha={false}
      open={open}
      defaultColor={value}
      onColorSelect={onSelect}
      onOutsideClick={closeColorPicker}
    >
      <div className='relative' onClick={openColorPicker}>
        <span
          className={cx('absolute right-5 top-2.5 w-5 h-5 cursor-pointer', {
            rounded: shape === ColorPreviewShape.Square,
            'rounded-full': shape === ColorPreviewShape.Circle,
          })}
          style={{ backgroundColor: value }}
        />
        <Input value={value} disabled={disabled} readOnly onFocus={onFocus} />
      </div>
    </ColorPickerPopover>
  );
}
